<template>
  <div class="editor">
    <CloseButton @close="$emit('call-editor', 'close')" />
    <div class="-header">
      <div class="--title">
        <span>{{ mode === "edit" ? "Edit" : "Add" }} Instruction</span>
      </div>
      <span class="--subtitle">{{ mode === "edit" ? "แก้ไข" : "เพิ่ม" }} การแนะนำวิธีการเรียน</span>
    </div>
    <div class="-body">
      <Block no-border>
        <TextArea
          label="คำแนะนำในการเรียน"
          :edata="newInstruction.instruction"
          prop="instruction"
          @input="handleInput"
          styles="height: 300px"
        />
      </Block>
      <Block no-border>
        <InputBox
          label="Stream URI"
          :edata="newInstruction.streamIntroPath"
          prop="streamIntroPath"
          @input="handleInput"
        />
      </Block>
      <div class="--controllers">
        <vs-button @click="saveData">Save</vs-button>
      </div>
    </div>
  </div>
</template>

<script>
import Block from "@/components/common-ui/block/index.vue";
import InputBox from "@/components/common-ui/forms/input-box/index.vue";
import TextArea from "@/components/common-ui/forms/textarea/index.vue";

export default {
  props: {
    mode: String,
    edata: Object,
    methods: Object,
  },
  components: {
    CloseButton: () => import("./editor-close"),
    Block,
    InputBox,
    TextArea
  },
  data() {
    return {
      assessmentOptions: [{ id: "", title: "" }],
      newInstruction: {
        instruction: "",
        streamIntroPath: ""
      }
    }
  },
  methods: {
    getAssessmentOptions() {
      return this.$store.state.MasterData.assessments;
    },
    transformAssessmentOptions(list) {
      if (list && Array.isArray(list)) {
        return list.map(item => {
          return { id: "", title: item.nameLocal };
        })
      }
      return [{ id: "", title: "No assessment options"}];
    },
    loadData() {
      if (this.mode === "edit") {
        this.$set(this, 'newInstruction', { ...this.edata });
        this.$forceUpdate();
      }
    },
    async saveData() {
      const res = await this.methods.updateCourseOutline(this.newInstruction);
      if (res) {
        this.$emit("call-editor", "close");
      }
    },
    handleInput({ prop, data}) {
      this.newInstruction[prop] = data;
    }
  },
  mounted() {
    this.loadData();
    this.$forceUpdate();
  }
}
</script>

<style lang="scss" scoped>
@import "common-scoped";

.editor {
  display: flex;
  flex-direction: column;

  & .-header {
    width: 100%;
    display: block;
    margin-bottom: 20px;

    & .--title {
      font-size: 2rem;
      color: #6f66b9;
      padding-bottom: 1rem;
      width: 100%;
      height: 3rem;
      border-bottom: 2px solid #e8e8e8;
    }
    & .--subtitle {
      margin-top: 1rem;
      font-size: 1rem;
    }
  }

  & .-body {
    display: flex;
    width: 80%;
    flex-direction: column;

    & .--controllers {
      margin-top: 20px;
    }
  }
}
</style>